module.exports = __webpack_public_path__ + "static/arabescosModal-9c721ab9cb10e776dc197f46595df890.svg";